import { useEffect } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import PageBanner from '../components/common/PageBanner'
import Container from '../components/common/Container'
import SubmissionForm from '../components/forms/SubmissionForm'

export default function SubmitOrganisation() {
  useEffect(() => {
    document.title = 'Submit an Organisation — Future of Farm Food Library'
  }, [])

  return (
    <>
      <PageBanner
        overline="Grow the ecosystem"
        headline="Submit an Organisation"
        subtext="Help us build a complete picture of the regenerative agriculture ecosystem in South Africa by adding an organisation to the directory."
      />

      <Box sx={{ py: { xs: 6, md: 8 }, backgroundColor: 'background.default' }}>
        <Container narrow>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              mb: 4,
              background: 'linear-gradient(120deg, rgba(138,154,91,0.14), rgba(138,154,91,0.05))',
              border: '1px solid rgba(138, 154, 91, 0.35)',
              borderRadius: 3,
              display: 'flex',
              gap: 2,
              alignItems: 'flex-start',
            }}
          >
            <InfoOutlinedIcon sx={{ color: '#B87333', fontSize: 22, mt: 0.25, flexShrink: 0 }} />
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                Before you submit
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                We review all submissions before adding them to the directory. The organisation should be actively working in regenerative agriculture or closely related food systems work in South Africa or the broader Southern African region. Submissions are typically reviewed within 5–10 business days.
              </Typography>
            </Box>
          </Paper>

          <SubmissionForm />
        </Container>
      </Box>
    </>
  )
}
